/* Default primitive and reference values, mostly used to:
  1) Put default values in React component props and function params, to avoid unnecesary rerenders.
  2) Avoid recreation of variables, constants between rerenders
*/
export const EMPTY_ARRAY = []
export const EMPTY_OBJECT = {}
export const DEFAULT_FUNC = () => { }
export const ZERO = 0
export const NUMERAL = '#'

/* Landings type */
export const ALL = 'all'
export const PROJECTS = 'projects'
export const PRODUCTS = 'products'
export const IMAGES = 'images'
export const ARTICLES = 'articles'
export const FOLDERS = 'folders'
export const PROFESSIONALS = 'professionals'
export const CACHED_FOLDERS = 'folders_landing'
export const COMPETITIONS = 'competitions'
export const EVENTS = 'events'
export const WIDGETS = 'widgets'
export const GALLERY = 'gallery'
export const ARTICLE_ARCHIVE = 'article-archive'

/* Url paths */
export const API = '/search/api/v1'
export const SEARCH_ALL_PATH = `/${ALL}`
export const SEARCH_ARTICLES_PATH = `/${ARTICLES}`
export const SEARCH_PROJECTS_PATH = `/${PROJECTS}`
export const SEARCH_PRODUCTS_PATH = `/${PRODUCTS}`
export const SEARCH_IMAGES_PATH = `/${IMAGES}`
export const SEARCH_PROFESSIONALS_PATH = `/${PROFESSIONALS}`
export const SEARCH_CACHED_FOLDERS_PATH = `/${CACHED_FOLDERS}`
export const ARTICLE_ARCHIVE_PATH = `/articles/filter`
export const WIDGETS_PATH = `/${WIDGETS}`
export const DOODLE_PATH = '/search/doodle'

/* Images url */
export const DEFAULT_IMAGE = 'https://assets.adsttc.com/doodles/flat/search/search_results.jpeg '
export const PROFESSIONAL_PLACEHOLDER_IMAGE = 'https://assets.adsttc.com/hayden/main-image-placeholder.jpg'
export const MYAD_FOLDER_IMAGES = 'https://my.adsttc.com/api/v1/folders/by_names'
export const FULL_BLUE_LOGO = 'https://assets.adsttc.com/doodles/flat/logo-blue-full.svg'
export const ISO_BLUE_LOGO = 'https://assets.adsttc.com/doodles/flat/logo-blue-isotype.svg'

// eslint-disable-next-line max-len
export const LOADER_BLUE = 'https://assets.adsttc.com/doodles/flat/loader-blue.gif'

/* My ArchDaily pagination size */
export const MYAD_FOLDER_PER_PAGE = 18

/* Available quantity of pages in the requestCachedFolders function */
export const MAX_CACHED_PAGES = 28

/* Query string to handle the search "query" as first */
export const SEARCH_QUERY = '?q='

/* Code to know when the Browser is Internet Explorer */
export const IS_EXPLORER = /* @cc_on!@ */false || !!document.documentMode

/* Array that allows a landing without a text search in the url to open, ignoring the default behaviour */
// NOTE: By default if you don't have a text search in the url E.g. '/search/all?q=house' you'll be redirect to the search home
export const SEARCH_TYPES_WITHOUT_TEXT = [PROJECTS, FOLDERS, PRODUCTS, IMAGES, PROFESSIONALS, ARTICLE_ARCHIVE]

/* Array that enables the landing to work with filters */
// NOTE: Besides of put the type of landing in this array you still have to add some configurations in the filters constants file
export const TYPES_WITH_FILTER = [PROJECTS, PRODUCTS, IMAGES, PROFESSIONALS, ARTICLE_ARCHIVE]

/* Array that enables the landing to render an Office widget within the gridview result items */
export const TYPES_WITH_OFFICES_WIDGET = [PROJECTS]

/* Array that enables the landing to render an Professionals widget within the gridview result items */
export const TYPES_WITH_PROFESSIONALS_WIDGET = [ALL, PROJECTS]

/* Array that enables the landing to render a Companies widget in the SearchHeader component */
export const TYPES_WITH_COMPANIES_WIDGET = [PRODUCTS]

/* Array that enables the landing to render actions */
export const TYPES_WITH_ACTIONS = [ALL, PROJECTS, PRODUCTS]

/* Array that enables the sort button */
export const TYPES_WITH_SORTING = [ARTICLE_ARCHIVE]

/* Array that enables the landing to render Follow Category Button */
export const TYPES_WITH_FOLLOW_BUTTON = [PROJECTS, PRODUCTS]

/* Types with inner search input */
export const TYPES_WITH_INNER_SEARCH = [ARTICLE_ARCHIVE]

export const TYPES_WITH_BREADCRUMBS = [ARTICLE_ARCHIVE]

/* Object with some configuration to each landing */
// NOTE: If you have to create a new landing, create a new key with the name of the landing and fill it with the correct data
export const RESULTS_DATA = {
  [ALL]: {
    searchType: ALL,
    request: 'allRequestResults'
  },
  [FOLDERS]: {
    searchType: FOLDERS,
    request: 'foldersRequestResults'
  },
  [ARTICLES]: {
    searchType: ARTICLES,
    request: 'articlesRequestResults'
  },
  [PROJECTS]: {
    searchType: PROJECTS,
    request: 'projectsRequestResults'
  },
  [PRODUCTS]: {
    searchType: PRODUCTS,
    request: 'productsRequestResults'
  },
  [IMAGES]: {
    searchType: IMAGES,
    request: 'mediasRequestResults'
  },
  [PROFESSIONALS]: {
    searchType: PROFESSIONALS,
    request: 'professionalsRequestResults'
  },
  [ARTICLE_ARCHIVE]: {
    searchType: ARTICLE_ARCHIVE,
    request: 'articleArchiveRequestResults'
  }
}

/* Object with the available breakpoints handled in the App by Javascript */
export const RESPONSIVE_BREAKPOINTS = {
  xSmall: 425,
  small: 768,
  large: 1040
}

/* Array of Regex to match mobile browser agents */
export const MOBILE_AGENTS = [/Android/, /webOS/, /iPhone/, /iPad/, /iPod/, /BlackBerry/, /Windows Phone/]

/* Array of objects with Social Networks share options */
export const SHARE_OPTIONS = [
  { name: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/sharer.php?u=' },
  { name: 'twitter', label: 'Twitter', url: 'https://twitter.com/intent/tweet?text=' },
  { name: 'pinterest', label: 'Pinterest', url: 'https://pinterest.com/pin/create/button/?url=' },
  { name: 'mail', label: 'Mail', url: 'mailto:?subject=' }
]

/* Array of objects with China market Social Networks share options */
export const SHARE_OPTIONS_CHINA = [
  { name: 'douban', label: 'Douban', url: 'http://shuo.douban.com/!service/share?href=' },
  { name: 'weibo', label: 'Weibo', url: 'http://service.weibo.com/share/share.php?url=' },
  { name: 'qq', label: 'QQ', url: 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' },
  { name: 'wechat', label: 'Wechat', url: 'https://www.facebook.com/sharer.php?u=' }
]

/* Object with the ArchDaily Twitter Accounts per market */
export const TWITTER_ACCOUNTS = {
  cl: 'archdailycl',
  us: 'archdaily',
  mx: 'archdailymx',
  co: 'archdailyco',
  pe: 'archdailype',
  br: 'archdailybr',
  cn: 'archdailycn'
}

/* Object with some keys to be handle on a keyboard browser event */
export const KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown'
}

/* Google Tag Manager constants */
export const PAGEVIEW = 'pageView'
export const GTM_PARAMS = {
  projects: {
    follow: {
      internalType: 'onclick',
      category: 'search-follow-button',
      action: '1202,follow,click',
      label: 'Project categories follow'
    },
    unfollow: {
      internalType: 'onclick',
      category: 'search-unfollow-button',
      action: '1203,unfollow,click',
      label: 'Project categories unfollow'
    },
    pageView: {
      internalType: 'onpageshow',
      category: 'projects-search',
      action: '1004,page_view',
      label: 'Projects search page_view'
    },
    filters: {
      dim1: 'categories',
      dim2: 'country',
      dim3: 'offices',
      dim4: 'companies',
      dim5: 'year',
      dim6: 'materials',
      dim7: 'min_area',
      dim8: 'max_area',
      dim9: 'color'
    }
  },
  products: {
    follow: {
      internalType: 'onclick',
      category: 'search-follow-button',
      action: '1204,follow,click',
      label: 'Products categories follow'
    },
    unfollow: {
      internalType: 'onclick',
      category: 'search-unfollow-button',
      action: '1205,unfollow,click',
      label: 'Products categories unfollow'
    },
    filters: {
      dim1: 'categories',
      dim2: 'country',
      dim3: 'bim',
      dim4: 'companies',
      dim5: 'product_type',
      dim6: 'use',
      dim7: 'materials'
    }
  }
}